import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.autocodeSchedules.components';

export default defineMessages({
    editScheduleLabel: {
        id: `${scope}.label.editschedule`,
        defaultMessage: 'Edit Schedule',
    },
    addScheduleLabel: {
        id: `${scope}.label.addschedule`,
        defaultMessage: 'Add Schedule',
    },
    nameColumn: {
        id: `${scope}.label.namecolumn`,
        defaultMessage: 'Name',
    },
    autocodeStopReasonCodeColumn: {
        id: `${scope}.label.autocodestopreasoncode`,
        defaultMessage: 'Stop Reason Code',
    },
    startTimeColumn: {
        id: `${scope}.label.starttimecolumn`,
        defaultMessage: 'Start Time',
    },
    lengthInMinutesColumn: {
        id: `${scope}.label.lengthinminutescolumn`,
        defaultMessage: 'Length in Minutes',
    },
    mondayActive: {
        id: `${scope}.label.mondayactive`,
        defaultMessage: 'Mon',
    },
    tuesdayActive: {
        id: `${scope}.label.tuesdayactive`,
        defaultMessage: 'Tue',
    },
    wednesdayActive: {
        id: `${scope}.label.wednesdayactive`,
        defaultMessage: 'Wed',
    },
    thursdayActive: {
        id: `${scope}.label.thursdayactive`,
        defaultMessage: 'Thu',
    },
    fridayActive: {
        id: `${scope}.label.fridayactive`,
        defaultMessage: 'Fri',
    },
    saturdayActive: {
        id: `${scope}.label.saturdayactive`,
        defaultMessage: 'Sat',
    },
    sundayActive: {
        id: `${scope}.label.sundayactive`,
        defaultMessage: 'Sun',
    },
    machinesColumn: {
        id: `${scope}.label.machinescolumn`,
        defaultMessage: 'Machines',
    },
    save: {
        id: `${scope}.label.save`,
        defaultMessage: 'Save',
    },
    customLengthInMinutes: {
        id: `${scope}.label.customlengthinminutes`,
        defaultMessage: 'Custom Length (minutes)',
    },
    useCustomLength: {
        id: `${scope}.label.usecustomlength`,
        defaultMessage: 'Use Custom Length',
    },
    splitOngoingStopOnAutocodeStart: {
        id: `${scope}.label.splitongoingstoponautocodestart`,
        defaultMessage: 'Split ongoing stop on start',
    },
    splitOngoingStopOnAutocodeEnd: {
        id: `${scope}.label.splitongoingstoponautocodeend`,
        defaultMessage: 'Split ongoing stop on end',
    },
    splitStart: {
        id: `${scope}.label.splitstart`,
        defaultMessage: 'Split on start',
    },
    splitEnd: {
        id: `${scope}.label.splitend`,
        defaultMessage: 'Split on end',
    },
    splitOngoingStops: {
        id: `${scope}.label.splitongoingstops`,
        defaultMessage: 'Split ongoing stops',
    },
});